import React, { useState, useEffect } from "react";
import { getCourseQuiz } from "../Common/apis";

const CourseQuiz = ({course}) => {
     const courseId = course?._id;
  const [quizData, setQuizData] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  useEffect(() => {
    if (courseId) {
      fetchQuiz();
    }
  }, [courseId]);

  const fetchQuiz = async () => {
    try {
      const res = await getCourseQuiz(courseId);
      setQuizData(res?.data || []);
    } catch (err) {
      console.error("Error fetching quiz", err);
    }
  };

  const currentQuestion = quizData[currentQuestionIndex];
  const totalQuestions = quizData.length;

  const handleNext = () => {
    if (currentQuestionIndex < totalQuestions - 1) {
      setCurrentQuestionIndex((prev) => prev + 1);
    }
  };
  return (
    <>
      <div
        className="bg-[#6953A3B2] rounded-[16px] p-[28px]"
        style={{ backdropFilter: "blur(20px)" }}
      >
        <div className="flex justify-between items-center pb-[16px]">
          <h6 className="font-[700] font-sans text-[24px] leading-[36px] text-[#FFFFFF]">
            Quiz
          </h6>
          <p className="flex gap-[6px] items-center font-[400] font-poppins text-[14px] text-[#6953A3] bg-[#FFFFFF] rounded-[16px] py-[4px] px-[8px]">
            <img src="/assets/slider/clock.svg" alt="" />
            16:35
          </p>
        </div>
         {currentQuestion ? (
          <div
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(243, 220, 186, 0.7) 100%)",
              backdropFilter: "blur(20px)",
            }}
            className="rounded-[12px] p-[20px]"
          >
            <div className="bg-[#6953A3] rounded-full p-[3px] flex items-center gap-[12px] mb-[12px]">
              <h6 className="h-[44px] w-[44px] rounded-full bg-[#FFFFFF] text-center text-[#263238] font-[500] font-sans text-[18px] flex justify-center items-center">
                {String(currentQuestionIndex + 1).padStart(2, "0")}
              </h6>
              <p className="font-[500] font-sans text-[18px] text-[#FFFFFF]">
                {currentQuestion.question}
              </p>
            </div>

            <div className="grid grid-cols-2 gap-[15px]">
              {currentQuestion.options.map((option, index) => {
                const optionLabel = String.fromCharCode(65 + index); // A, B, C...
                return (
                  <div
                    key={index}
                    className="bg-[#FFFFFF] rounded-[8px] py-[7px] px-[12px] flex items-center gap-[13px]"
                  >
                    <h6 className="h-[36px] w-[36px] rounded-full bg-[#6953A3] text-[#FFFFFF] flex justify-center items-center font-[500] font-sans text-[18px]">
                      {optionLabel}
                    </h6>
                    <p className="font-[500] font-sans text-[18px] text-[#263238]">
                      {option}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <p className="text-white text-center mt-6">No quiz available</p>
        )}
        <div className="mt-[18px] bg-[#F4F3F6] rounded-full px-[30px] py-[14px] flex justify-between items-center">
          <div className="flex gap-[14px] items-center">
            <div className="w-full max-w-[200px]">
              <input
                type="range"
                min="0"
                max={totalQuestions - 1}
                value={currentQuestionIndex}
                readOnly
                className="w-full bg-[#EDE8E3] range-slider"
              />
            </div>
            <h6 className="font-[600] font-sans text-[16px] text-[#757575]">
              {currentQuestionIndex + 1}/{totalQuestions}
            </h6>
          </div>
          <button
            className="font-[400] font-roboto text-[16px] text-[#263238] bg-[#F1E60D] py-[8px] px-[28px] rounded-full"
            onClick={handleNext}
            disabled={currentQuestionIndex === totalQuestions - 1}
          >
            Continue
          </button>
        </div>
        
        {/* <div className="grid grid-cols-1 gap-[12px]">
          <div
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(243, 220, 186, 0.7) 100%)",
              backdropFilter: "blur(20px)"
            }}
            className="rounded-[12px] p-[20px]"
          >
            <div className="bg-[#6953A3] rounded-full p-[3px] flex items-center gap-[12px] mb-[12px]">
              <h6 className="h-[44px] w-[44px] rounded-full bg-[#FFFFFF] text-center text-[#263238] font-[500] font-sans text-[18px] leading-[-0.32px] flex justify-center items-center">
                01
              </h6>
              <p className="font-[500] font-sans text-[18px] leading-[24px] text-[#FFFFFF]">
                What is Meaning of AWS Skill Builder?
              </p>
            </div>
            <div className="grid grid-cols-2 gap-[15px]">
              <div className="bg-[#FFFFFF] rounded-[8px] py-[7px] px-[12px] flex items-center gap-[13px]">
                <h6 className="h-[36px] w-[36px] rounded-full bg-[#6953A3] text-[#FFFFFF] flex justify-center items-center font-[500] font-sans text-[18px] leading-[24px] tracking-[-0.32px]">
                  A
                </h6>
                <p className="font-[500] font-sans text-[18px] leading-[-0.32px] text-[#263238]">
                  Azure Functions
                </p>
              </div>
              <div className="bg-[#FFFFFF] rounded-[8px] py-[7px] px-[12px] flex items-center gap-[13px]">
                <h6 className="h-[36px] w-[36px] rounded-full bg-[#6953A3] text-[#FFFFFF] flex justify-center items-center font-[500] font-sans text-[18px] leading-[24px] tracking-[-0.32px]">
                  B
                </h6>
                <p className="font-[500] font-sans text-[18px] leading-[-0.32px] text-[#263238]">
                  Azure Functions
                </p>
              </div>
              <div className="bg-[#F1E60D] rounded-[8px] py-[7px] px-[12px] flex items-center gap-[13px]">
                <img src="/assets/slider/done.svg" alt="" />
                <p className="font-[500] font-sans text-[18px] leading-[-0.32px] text-[#263238]">
                  Azure Functions
                </p>
              </div>
              <div className="bg-[#FFFFFF] rounded-[8px] py-[7px] px-[12px] flex items-center gap-[13px]">
                <h6 className="h-[36px] w-[36px] rounded-full bg-[#6953A3] text-[#FFFFFF] flex justify-center items-center font-[500] font-sans text-[18px] leading-[24px] tracking-[-0.32px]">
                  D
                </h6>
                <p className="font-[500] font-sans text-[18px] leading-[-0.32px] text-[#263238]">
                  Azure Functions
                </p>
              </div>
            </div>
          </div>
          <div
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(243, 220, 186, 0.7) 100%)",
              backdropFilter: "blur(20px)"
            }}
            className="rounded-[12px] p-[20px]"
          >
            <div className="bg-[#6953A3] rounded-full p-[3px] flex items-center gap-[12px] mb-[12px]">
              <h6 className="h-[44px] w-[44px] rounded-full bg-[#FFFFFF] text-center text-[#263238] font-[500] font-sans text-[18px] leading-[-0.32px] flex justify-center items-center">
                02
              </h6>
              <p className="font-[500] font-sans text-[18px] leading-[24px] text-[#FFFFFF]">
                What is Use of AWS?
              </p>
            </div>
            <div className="grid grid-cols-2 gap-[15px]">
              <div className="bg-[#FFFFFF] rounded-[8px] py-[7px] px-[12px] flex items-center gap-[13px]">
                <h6 className="h-[36px] w-[36px] rounded-full bg-[#6953A3] text-[#FFFFFF] flex justify-center items-center font-[500] font-sans text-[18px] leading-[24px] tracking-[-0.32px]">
                  A
                </h6>
                <p className="font-[500] font-sans text-[18px] leading-[-0.32px] text-[#263238]">
                  Clarity
                </p>
              </div>
              <div className="bg-[#FFFFFF] rounded-[8px] py-[7px] px-[12px] flex items-center gap-[13px]">
                <h6 className="h-[36px] w-[36px] rounded-full bg-[#6953A3] text-[#FFFFFF] flex justify-center items-center font-[500] font-sans text-[18px] leading-[24px] tracking-[-0.32px]">
                  B
                </h6>
                <p className="font-[500] font-sans text-[18px] leading-[-0.32px] text-[#263238]">
                  Clarity
                </p>
              </div>
              <div className="bg-[#F1E60D] rounded-[8px] py-[7px] px-[12px] flex items-center gap-[13px]">
                <h6 className="h-[36px] w-[36px] rounded-full bg-[#6953A3] text-[#FFFFFF] flex justify-center items-center font-[500] font-sans text-[18px] leading-[24px] tracking-[-0.32px]">
                  C
                </h6>
                <p className="font-[500] font-sans text-[18px] leading-[-0.32px] text-[#263238]">
                  Clarity
                </p>
              </div>
              <div className="bg-[#FFFFFF] rounded-[8px] py-[7px] px-[12px] flex items-center gap-[13px]">
                <h6 className="h-[36px] w-[36px] rounded-full bg-[#6953A3] text-[#FFFFFF] flex justify-center items-center font-[500] font-sans text-[18px] leading-[24px] tracking-[-0.32px]">
                  D
                </h6>
                <p className="font-[500] font-sans text-[18px] leading-[-0.32px] text-[#263238]">
                  Clarity
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-[18px] bg-[#F4F3F6] rounded-full px-[30px] py-[14px] flex justify-between items-center">
          <div className="flex gap-[14px] items-center">
            <div className="w-full max-w-[200px]">
              <input
                type="range"
                min="0"
                max="5"
                value="1"
                className="w-full bg-[#EDE8E3] range-slider"
              />
            </div>
            <h6 className="font-[600] font-sans text-[16px] leading-[20px] text-[#757575]">
              1/5
            </h6>
          </div>
          <button className="font-[400] font-roboto text-[16px] leading-[26px] text-[#263238] bg-[#F1E60D] py-[8px] px-[28px] rounded-full">
            Continue
          </button>
        </div> */}
      </div>
    </>
  );
};

export default CourseQuiz;
